import { Col, Row, Typography } from "@commonlibs";
import InfoPopover from "ui/common/components/feedback/InfoPopover/InfoPopover";
import useTranslate from "ui/locale/hooks/useTranslate";
import { FormGridLabelProps } from "./FormGridLabel.types";

export function FormGridLabel({ label, showOptionalLabel, popover }: FormGridLabelProps) {
    const translate = useTranslate();

    return (
        <Row alignItems="center" gap={5}>
            <Col justifyContent="flex-start">
                <Typography variant="body2Strong" light>
                    {label}
                </Typography>
                {showOptionalLabel && (
                    <Typography variant="body3Regular" light css={{ marginTop: "-0.25rem" }}>
                        {`(${translate("optional")})`}
                    </Typography>
                )}
            </Col>
            {popover && <InfoPopover text={popover} />}
        </Row>
    );
}
